export default class ChangePasswordInfo {
    currentPassword: string;
    newPassword: string;
    confirmPassword:string;
}